import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

export const getAllSettings = async () => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.get(`${endpoint}/settings`, config);
        return response.data;
    } catch (error) {
        console.error('Error fetching settings:', error);
        throw error;
    }
};

export const getSettingByKey = async (key) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.get(`${endpoint}/settings/${key}`, config);
        return response.data;
    } catch (error) {
        console.error('Error fetching setting:', error);
        throw error;
    }
};

export const createSetting = async (formData) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.post(`${endpoint}/settings`, formData, config);
        return response.data;
    } catch (error) {
        console.error('Error creating setting:', error);
        throw error;
    }
};

export const updateSetting = async (key, formData) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.put(`${endpoint}/settings/${key}`, formData, config);
        return response.data;
    } catch (error) {
        console.error('Error updating setting:', error);
        throw error;
    }
};

export const deleteSetting = async (key) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.delete(`${endpoint}/settings/${key}`, config);
        return response.data;
    } catch (error) {
        console.error('Error deleting setting:', error);
        throw error;
    }
};